import { useOfferCardContext } from '../context/offerCardContext';

export const useGallery = () => {
  const { gallery } = useOfferCardContext();

  return gallery;
};
